const FALLBACK = { min: 0, max: 100 };

const isNum = (v) => typeof v === "number" && Number.isFinite(v);

// Round outward to a 1/2/5 × 10^n step so the dial ends on readable numbers.
function niceBounds(lo, hi) {
  const span = hi - lo;
  const raw = span / 5;
  const pow = 10 ** Math.floor(Math.log10(raw));
  const f = raw / pow;
  const step = (f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10) * pow;
  return { min: Math.floor(lo / step) * step, max: Math.ceil(hi / step) * step };
}

/**
 * Gauge dial range.
 * Explicit config.min/max win. Otherwise the last-24h min/max (`stat`, from /dashboard/data/stats)
 * is padded 10% and rounded. `outOfRange` is "below" | "above" | null for the current value.
 */
export function resolveGaugeRange(config = {}, stat = null, value = null) {
  let range;
  let auto = false;
  const min = Number(config.min);
  const max = Number(config.max);
  if (config.min != null && config.max != null && isNum(min) && isNum(max) && max > min) {
    range = { min, max };
  } else if (stat && isNum(stat.min) && isNum(stat.max)) {
    const pad = (stat.max - stat.min) * 0.1 || Math.abs(stat.max) * 0.1 || 1;
    range = niceBounds(stat.min - pad, stat.max + pad);
    auto = true;
  } else {
    range = FALLBACK;
  }
  const v = Number(value);
  const outOfRange = !isNum(v) ? null : v < range.min ? "below" : v > range.max ? "above" : null;
  return { ...range, auto, outOfRange };
}
